document.addEventListener('DOMContentLoaded', function () {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.tagName === 'IFRAME') {
            node.addEventListener('load', function () {
              var iframeDocument = node.contentDocument || node.contentWindow.document;
              if (iframeDocument) {
                var style = iframeDocument.createElement('style');
                style.textContent = `
                .hbspt-form form {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }

                .hbspt-form form .actions {
                    margin: 0;
                    padding: 0;
                }

                .hbspt-form form .hs-submit input {
                    background-color: black;
                    text-color: white;
                    border: none;
                }

                .field {
                  margin-bottom: 0 !important;
                }

                .hbspot-form form .field {
                  margin-bottom: 0 !important;
                }

                .hbspt-form form .hs-submit input:hover {
                    background-color: black !important;
                    text-color: white !important;
                    border: none !important;
                }

                .hbspt-form form .hs-submit .actions {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                }

                .hbspt-form form .hs-email label {
                  display: none !important;
                }

                .hbspt-form form label {
                  display: none !important;
                }
              `;
                iframeDocument.head.appendChild(style);

                var input = iframeDocument.querySelector('input[type="email"]');
                console.log({ input });

                var inputs = iframeDocument.querySelectorAll('input');
                console.log({ inputs });

                if (input) {
                  input.placeholder = 'Email Address';
                }
              } else {
                console.log('iframe document not accessible');
              }
            });
          }
        });
      });
    });

    var hubspotFormContainer = document.querySelectorAll('.hubspot-form');
    hubspotFormContainer.forEach(function (container) {
      observer.observe(container, { childList: true, subtree: true });
    });
  });